<template>
 <div class="home">
    <App-navigation></App-navigation>
  
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
              Available movies that can be viewed on the go
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="loads()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}" >
                  <tr>
                <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.movName.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.desc }}</td>
                  <td class="text-xs-center">{{item.link}}</td>
                  <td class="text-xs-center">{{item.useradd ? item.useradd : item.useredit }}</td>
                  <td class="text-xs-center">{{item.dateadded}}</td>
                  <td class="justify-center layout px-0">
                     <Delete-watch :name="item.name" v-if="crc(staff.rights,'023')"></Delete-watch>
                        
                  </td>
                  </tr>
                                      
                </template>
              </v-data-table>
              
            </v-flex>
        </v-layout>
        <Add-watch  v-if="crc(staff.rights,'022')"></Add-watch>
     </v-container>
     
     
  </div>
</template>

<script>
// @ is an alias to /src
import AddWatch from '@/components/Watch/AddWatch.vue'
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import DeleteWatch from '@/components/Watch/DeleteWatch.vue'

import {checkright} from '@/validator'

export default {
  name: 'watch',
  data(){
      return {
          staff:this.$store.getters.getStaff,
          dialog:false,
          dialogIma:{},
          search:'',
          counter:0,
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'NAME',
              align:'center',
              sortable:true,
              value:'name'
            },
            {
              text:'DESCRIPTION',
              align:'center',
              sortable:true,
              value:'desc'
            }, 
            {
              text:'LINK',
              align:'center',
              sortable:true,
              value:'link'
            },
            
            {
              text:'ADDED/EDITED BY',
              align:'center',
              sortable:true,
              value:'useradd'
            },
             {
              text:'DATE ADDED',
              align:'center',
              sortable:true,
              value:'dateadded'
            },
            {
              text:'ACTIONS',
              sortable:false,
             
            }
          ],
          listPrimitive:null
      }
  },
  methods:{
        loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateWatch',false);
                   
           value = self.$store.getters.getWatch;
            //console.log(value);
            return value;
           
            
        },
      
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
    AddWatch,
    DeleteWatch,
    
  }
}
</script>
